export default __webpack_public_path__ + "static/media/c-serach.8c8e9e4d.svg";